export default __webpack_public_path__ + "static/pragicts-itops-servers-cc541fd2b6b0c2da2b6ac8519405e5c7.jpg";